import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { healthcareFraud } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class HealthcareFraudComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'healthcare_fraud'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.healthcare.confirmation
  }

  /*
   * Combine the HCF unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const {
      allegation,
      allegation_other,
      hhs_program_type,
      hhs_program_type_other
    } = formData

    const detail = {
      allegation,
      allegation_other,
      hhs_program_type,
      hhs_program_type_other
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(HealthcareFraudComplaint, healthcareFraud)
  )
)
